export default __webpack_public_path__ + "static/media/bg-login.345f1ad5.jpg";